import { create } from 'zustand';

export type AlertType = 'info' | 'success' | 'warning' | 'error';

export interface AlertOptions {
  title?: string;
  message: string;
  type?: AlertType;
  confirmText?: string;
}

interface AlertState {
  visible: boolean;
  title: string;
  message: string;
  type: AlertType;
  confirmText: string;
  resolve: (() => void) | null;
  open: (options: AlertOptions | string) => Promise<void>;
  close: () => void;
}

export const useAlertStore = create<AlertState>()((set, get) => ({
  visible: false,
  title: '',
  message: '',
  type: 'info',
  confirmText: '确认',
  resolve: null,
  open: (options) =>
    new Promise<void>((resolve) => {
      const opts = typeof options === 'string' ? { message: options } : options;
      set({
        visible: true,
        title: opts.title ?? '',
        message: opts.message,
        type: opts.type ?? 'info',
        confirmText: opts.confirmText ?? '确认',
        resolve,
      });
    }),
  close: () => {
    const { resolve } = get();
    resolve?.();
    set({ visible: false, resolve: null });
  },
}));

/** 在任何地方（包括非组件代码）调用弹窗，替代 window.alert */
export function showAlert(message: string, options?: Omit<AlertOptions, 'message'>): Promise<void> {
  return useAlertStore.getState().open({ message, ...options });
}
